import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// The portal's pages by the name a back button gives them. Detail pages first,
// so '/hub/coverage/7' doesn't read as My coverage.
const PLACES = [
  [/^\/hub\/coverage\/\d+/, 'The policy'],
  [/^\/hub\/sessions\/\d+/, 'The session'],
  [/^\/hub\/library\/\d+/, 'The file'],
  [/^\/hub\/recordings\/\d+/, 'The recording'],
  [/^\/hub\/coverage(\?|$)/, 'My coverage'],
  [/^\/hub\/sessions(\?|$)/, 'Sessions'],
  [/^\/hub\/library(\?|$)/, 'Library'],
  [/^\/hub\/messages(\?|$)/, 'Messages'],
  [/^\/hub\/details(\?|$)/, 'My details'],
  [/^\/hub\/?(\?|$)/, 'Home'],
];

const IN_PORTAL = /^\/hub(\/|\?|$)/;

// vue-router's web history records, on each entry, the path it was opened from.
const behind = () => {
  const back = window.history.state?.back;
  return typeof back === 'string' && IN_PORTAL.test(back) ? back : null;
};

/**
 * A detail page's way back (XN-4417): to the page the person came from, named,
 * the way the browser's own Back would take them, scroll and state kept. From
 * the page's own list it keeps the list's label ("All coverage"). With nothing
 * in the portal behind it (an email's link, a new tab, sign-in) the list, fresh:
 * never out of the portal.
 *
 * @param {{ to: string|object, label: string, list: RegExp }} home the page's list:
 *   where to go fresh, its label, and the paths that count as coming from it
 */
export function useBackTo(home) {
  const route = useRoute();
  const router = useRouter();

  const label = computed(() => {
    route.fullPath; // read again for each entry the page is reused for
    const back = behind();
    if (!back || home.list.test(back)) return home.label;
    return PLACES.find(([path]) => path.test(back))?.[1] ?? 'Back';
  });

  const go = () => {
    if (behind()) router.back();
    else router.push(home.to);
  };

  return { label, go };
}
